import React, { Component } from "react";
import Typography from "@mui/material/Typography";
import AttributeModul from "./Attributes/AttributeModul";
import DataStore from "../stores/DataStore";

/**
 * Modul, welches für das Anzeigen genau eines Themas (z.b. einer Seite) zuständig ist
 */
class Theme extends Component {
  constructor(params) {
    super(params);
    this.state = {};
    this.attributeModuls = [];
  }

  /**
   * Funktion zum Einbau der EditToolbar auf einer Seite der Attributbearbeitung
   * ggf anpassungen de rÜbegrebenen Funktionen hier!
   */
  getEditToolbar() {
    const { themeOptions: { editToolbar } = {} } = this.props;
    const { editToolbarSettings } = DataStore;
    const { EditToolbar, getEditToolbarProps, controller, mode, LayerStore } = editToolbarSettings
    const p = getEditToolbarProps();
    p.onChange = ({ action }) => {
      DataStore.geometryChanges = controller.getChangesInSelection()
      if (action && action.constructor.type == "create") {
        const attributes = action.state.attributes;
        DataStore.dataHandler.insertData(Object.keys(attributes).map(key => { return { id: key, value: attributes[key] } }));
      }
    }
    p.noLayerList = false;
    if (mode == "new") {
      p.forceInsert = true;
      p.onBeforeChange = (
        ({ action }) => {
          if (action && action.constructor.type == "create") {
            controller.hasAttributiveChanges = false;
            controller.historyManager.clear();
            LayerStore.layerManager.redraw();
          }
          return action;
        }
      )
      // p.selection = []  
    }
    return <EditToolbar
      {...p}
    />;
  }

  /**
   * gibt die Attribute zu dem Thema wieder
   * @returns {AttributeModul[]}
   */
  getAttributeModuls() {
    const { themeOptions: { title, attributes = [], editToolbar } = {} } = this.props;
    if (title == "editToolbar") return this.getEditToolbar();

    this.attributeModuls = [];
    for (let i = 0; i < attributes.length; i++) {
      this.attributeModuls.push(
        <AttributeModul attribute={attributes[i]} key={attributes[i].id} />
      );
    }
    this.messageHandler.logDebugFormatted(
      "Theme",
      "getAttributeModuls",
      "",
      this.props,
      this.state,
      this.attributeModuls
    );
    return this.attributeModuls;
  }

  /**
   * baut den Header aus titel und Beschreibung
   * wird ausgeblendet, wenn hideHeader übergeben wird
   */
  getHeader() {
    const {
      themeOptions: {
        title = "",
        description = "",
        hideHeader = false,
        icon = null,
        attributes = [],
      } = {},
    } = this.props;
    if (hideHeader) {
      return <div />;
    }

    const headerStyle = { align: "center" };
    return (
      <div style={headerStyle}>
        <Typography variant="h5" component="h2">
          {title}
        </Typography>
        <Typography color="textSecondary" gutterBottom>
          {description}
        </Typography>
      </div>
    );
  }

  /**
   * Modul, welches die Anzeige eines einzelnen Themas zuständig ist.
   * @render
   * @param {object} this.state
   * @param {object} this.props.themeOption
   * @param {string} [this.props.themeOption.title = ""] - Titel des Themas
   * @param {string} [this.props.themeOption.description = ""] - Beschreibung des Themas
   * @param {object}[ this.props.themeOption.icon] - Icon, dass ggf. angezeigt wird
   * @param {Array} [this.props.themeOption.attributes =[]] - Array mit Attributen im Thema
   */
  render() {
    const {
      themeOptions: {
        title = "",
        description = "",
        hideHeader = false,
        icon = null,
        attributes = [],
      } = {},
      editToolbar,
      messageModul,
    } = this.props;
    this.messageHandler = DataStore.getHandler().messageHandler;
    this.requestHandler = DataStore.getHandler().requestHandler;
    if (title === "editToolbar") {
      return this.getEditToolbar();
    }
    this.messageHandler.logDebugFormatted(
      "Theme",
      "render",
      "",
      this.props,
      this.state
    );
    return (
      // TODO: richtig einbauen...
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {this.getHeader()}
        {messageModul}
        <div>{this.getAttributeModuls()}</div>
      </div>
    );
  }
}
export default Theme;
